module.exports = __webpack_public_path__ + "static/media/guide_step8.8bc004a1.png";